function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
import { simpleBlockContent } from '../index.js';
var schema = defineObject('pubmedArticleListing', {
    title: {
        title: 'Title',
        type: 'string'
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    action: {
        title: 'Action',
        type: 'link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    title: z.string(),
    description: simpleBlockContent.validator,
    action: link.validator
}).partial();
schema.pubmedArticleListing;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=pubmedArticleListing.js.map